import type { CopyShape } from "@tami/core/intl";

import type { PROPOSALS_SCRIPT_COPY_PT_BR } from "../proposals-script.copy";

export const PROPOSALS_SCRIPT_COPY_EN_US: CopyShape<typeof PROPOSALS_SCRIPT_COPY_PT_BR> = {
  propIntro: {
    narrative: "On the Collab side, pricing isn't a single brand deal: it's a quote with several creators inside.",
  },
  propToolbar: {
    narrative: "Your proposals stay saved and reusable — the next brand starts from the last one, not from scratch.",
    callout: "Search, duplicate and put together the next proposal in minutes.",
  },
  propOverview: {
    narrative: "One proposal per brand, with the full roster package.",
  },
  propCards: {
    narrative: "Each card shows what the brand pays, how much you keep as commission and who from the roster is in the package.",
    callout: "The photos at the bottom are the creators in the proposal — three, and the rest become +N.",
  },
  propConverted: {
    narrative: "Deal closed? The proposal becomes a campaign with the creators and deliverables already filled in.",
    callout: "Converted ones are flagged — you don't redo what's already a campaign.",
  },
};
